/* import __COLOCATED_TEMPLATE__ from './progress-bar.hbs'; */
import { htmlSafe } from '@ember/template';
import { computed } from '@ember/object';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-progress-bar';

/** Renders a progress bar that fills its parent container. */
export default Component.extend({
  classNames: [CLASS_NAME],
  CLASS_NAME,

  progress: null,

  /** @type {Ember.String.htmlSafe} The `style` value which dictates the progress bar's width. */
  _fillStyle: computed('progress', function () {
    const style = this.get('progress') ? `transform: scaleX(${this.get('progress')})` : '';
    return htmlSafe(style);
  }),
});
